export { default } from './BlockWordRotator'